import * as React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

const StyledHTMLToolTip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 350,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}));

function HTMLToolTip({ title, children, ...rest }) {
  return (
    <StyledHTMLToolTip
      title={title}
      {...rest}
    >
      {children}
    </StyledHTMLToolTip>
  );
}

HTMLToolTip.propTypes = {
  title: PropTypes.node,
  children: PropTypes.node,
};

export default HTMLToolTip;
